import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const ErrorText = styled(Sticker.Text)`
  word-break: break-word;
`;
